import * as z from "zod";

export const startWorkOrder = {
  name: "startWorkOrder" as const,
  input: z.object({ workOrderId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
